// Query Comment Mapper
import { QueryCommentEntity } from "../../domain/entities/QueryCommentEntity";
import { QueryCommentDTO } from "../models/QueryCommentDTO";
import { QueryMapper } from "./QueryMapper";

export class QueryCommentMapper {
  static toDomain(dto: QueryCommentDTO): QueryCommentEntity {
    // Parse MySQL datetime format properly (YYYY-MM-DD HH:MM:SS)
    // Replace space with 'T' to make it ISO 8601 compatible
    const isoDateString = dto.created_at.replace(' ', 'T');
    
    return {
      commentId: dto.comment_id,
      queryId: dto.query_id,
      user: QueryMapper.userToDomain(dto.user),
      comment: dto.comment,
      createdAt: new Date(isoDateString),
    };
  }

  static toDTO(entity: QueryCommentEntity): QueryCommentDTO {
    return {
      comment_id: entity.commentId,
      query_id: entity.queryId,
      user: QueryMapper.userToDTO(entity.user),
      comment: entity.comment,
      created_at: entity.createdAt.toISOString(),
    };
  }
}

